import modal from './blockerModal';
import DataLayer from '../../../../utopiamain/assets/js/lib/dataLayer';
export default class DetectBlocker {

  constructor() {
    this.dataLayer = new DataLayer( window.dataLayer || [] );
    this.activatedPostTypes = [
      'post',
      'utopia_ratgeber',
      'utopia_fragen',
      'utopia_gallery',
      'utopia_siegel',
      'utopia_sponsored',
      'ut_sponsored_gallery'
    ];
    this.cookieName = 'ut_blocker';
    this.cookieExpireDate = 1;
    this.addScrollEvent();
    this.addOnClickEvent();
  }

  addOnClickEvent() {
    $('footer').on( 'click', '.blocker-btn', () => {
      this.setCookie();
    });
  }

  addScrollEvent() {
    $(window).one( 'scroll', () => {
      this.init();
    });
  }

  init() {
    if ( ! this.activatedPostTypes.includes( this.getPostType() ) ) return;
    this.adsBlocked(( blocked ) => {
      if (blocked) {
        window.dataLayer.push({
          event: 'AdBlocker',
          eventCatecory: 'AdBlocker',
          eventAction: 'AdBlocker Count',
          eventLabel: 'on'
        });
        if ( !this.getCookie() ) {
          window.dataLayer.push({
            event: 'AdBlocker',
            eventCatecory: 'AdBlocker',
            eventAction: 'AdBlocker Modal',
            eventLabel: 'show'
          });
          modal( $( 'footer' ) );
          let $modal = $( '#utabHinweisModal' );
          $modal.modal( 'show' );
        }
      } else {
        window.dataLayer.push({
          event: 'AdBlocker',
          eventCatecory: 'AdBlocker',
          eventAction: 'AdBlocker Count',
          eventLabel: 'off'
        });
      }
    });
  }

  adsBlocked(callback) {
    const url = 'https://' + window.location.host + '/advertisement.js';

    const requestConfig = {
      method: 'HEAD',
      mode: 'no-cors'
    };

    const request = new Request(url, requestConfig);

    fetch(request).then(function(response) {
      return response;
    }).then(function(response) {
      callback(false);
    }).catch(function(e) {
      callback(true);
    });
  }

  getPostType() {
    return this.dataLayer.getKey( 'pagePostType' );
  }

  getCookie() {
    const name = this.cookieName + '=';
    const cookies = ( document.cookie ) ? document.cookie.split(';') : [];
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return true;
      }
    }
    return false;
  }

  setCookie() {
    let d = new Date();
    d.setTime(d.getTime() + (this.cookieExpireDate * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = this.cookieName + '=ut_blocker ;' + expires + ';path=/';
  }

}
